var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var MultisigTxStatus;
(function (MultisigTxStatus) {
    MultisigTxStatus["Created"] = "created";
})(MultisigTxStatus || (MultisigTxStatus = {}));
export class Appwrite {
    constructor(appwrite_url, project_id) {
        this.getMultiSigs = (memberPk) => __awaiter(this, void 0, void 0, function* () {
            const functions = yield this.getFunctions();
            const executionMethod = yield this.getExecutionMethod();
            const res = yield functions.createExecution('get_multisigs', undefined, undefined, `?memberPk=${encodeURIComponent(memberPk)}`, executionMethod.GET);
            if (res.responseStatusCode !== 200) {
                throw new Error(`Failed to getMultiSigs. ${res.responseBody}`);
            }
            const data = JSON.parse(res.responseBody);
            if (data.success === false) {
                throw new Error(`Error Occured: ${data.data}`);
            }
            return data.data;
        });
        this.createMultiSig = (name, threshold, pubKeys) => __awaiter(this, void 0, void 0, function* () {
            const functions = yield this.getFunctions();
            const body = { "name": name, "threshold": threshold, "pubKeys": pubKeys };
            const executionMethod = yield this.getExecutionMethod();
            const res = yield functions.createExecution('create_multisig', JSON.stringify(body), undefined, undefined, executionMethod.POST);
            if (res.responseStatusCode !== 200) {
                throw new Error(`Failed to createMultiSig. ${res.responseBody}`);
            }
            const data = JSON.parse(res.responseBody);
            if (data.success === false) {
                throw new Error(`Error Occured: ${data.data}`);
            }
            return data.data;
        });
        this.createMultiSigTx = (public_key, rpc, prefix, signature, body_bytes, messages, chain_id, signer_address, fee) => __awaiter(this, void 0, void 0, function* () {
            const functions = yield this.getFunctions();
            const body = { public_key, rpc, prefix, signature, body_bytes, messages, chain_id, signer_address, fee };
            const executionMethod = yield this.getExecutionMethod();
            const res = yield functions.createExecution('create_multisig_tx', JSON.stringify(body), undefined, undefined, executionMethod.POST);
            if (res.responseStatusCode !== 200) {
                throw new Error(`Failed to createMultiSigTx. ${res.responseBody}`);
            }
            const data = JSON.parse(res.responseBody);
            if (data.success === false) {
                throw new Error(`Error Occured: ${data.data}`);
            }
            return data.data;
        });
        this.signMultiSigTx = (public_key, rpc, fee, prefix, signature, signer_address) => __awaiter(this, void 0, void 0, function* () {
            const functions = yield this.getFunctions();
            const body = { public_key, rpc, fee, prefix, signature, signer_address };
            const executionMethod = yield this.getExecutionMethod();
            const res = yield functions.createExecution('sign_multisig_tx', JSON.stringify(body), undefined, undefined, executionMethod.POST);
            if (res.responseStatusCode !== 200) {
                throw new Error(`Failed to signMultiSigTx. ${res.responseBody}`);
            }
            const data = JSON.parse(res.responseBody);
            if (data.success === false) {
                throw new Error(`Error Occured: ${data.data}`);
            }
            return data.data;
        });
        this.deleteMultisigTx = (tx_id) => __awaiter(this, void 0, void 0, function* () {
            const functions = yield this.getFunctions();
            const body = { tx_id };
            const executionMethod = yield this.getExecutionMethod();
            const res = yield functions.createExecution('delete_multisig_tx', JSON.stringify(body), undefined, undefined, executionMethod.POST);
            if (res.responseStatusCode !== 200) {
                throw new Error(`Failed to deleteMultisigTx. ${res.responseBody}`);
            }
            const data = JSON.parse(res.responseBody);
            if (data.success === false) {
                throw new Error(`Error Occured: ${data.data}`);
            }
            return data.data;
        });
        this.isServer = typeof window === 'undefined';
        this.initializeClient(appwrite_url, project_id);
    }
    initializeClient(appwrite_url, project_id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isServer) {
                const { Client } = yield import('node-appwrite');
                this.client = new Client();
            }
            else {
                const { Client } = yield import('appwrite');
                this.client = new Client();
            }
            this.client.setEndpoint(appwrite_url).setProject(project_id);
        });
    }
    getFunctions() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isServer) {
                const { Functions } = yield import('node-appwrite');
                return new Functions(this.client);
            }
            else {
                const { Functions } = yield import('appwrite');
                return new Functions(this.client);
            }
        });
    }
    getExecutionMethod() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isServer) {
                const { ExecutionMethod } = yield import('node-appwrite');
                return ExecutionMethod;
            }
            else {
                const { ExecutionMethod } = yield import('appwrite');
                return ExecutionMethod;
            }
        });
    }
}
//# sourceMappingURL=appwrite.js.map